var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.884 14.444c-.158-.851-.761-2.083-1.938-2.756-.682-.39-1.822-.735-3.435-.146l-4.435 1.884-9.387-5.81a1.005 1.005 0 00-1.048-.002l-1.518.927a1.004 1.004 0 00-.462.674c-.05.28.02.569.195.794l6.357 8.17.346.446 1.975-.72-6.412-8.241.036-.022 9.306 5.758c.024.015.053.016.078.029a.993.993 0 00.19.07c.062.017.12.03.182.035a.99.99 0 00.188-.007.945.945 0 00.197-.041c.027-.01.056-.005.082-.017l4.862-2.067c.678-.247 1.253-.238 1.71.022.58.332.895 1.01.964 1.385.097.519-1.49 1.093-2.012 1.282l-8.403 3.059-1.974.719-7.992 2.908c-.008.004-.875.344-1.144-.111-.465-.79-1.206-2.227-1.747-3.297l2.457 1.525c.283.175.635.197.937.062l4.766-2.143-1.264-1.625-3.837 1.726-2.851-1.77a.999.999 0 00-.87-.09l-1.257.458a1.002 1.002 0 00-.555 1.382c.067.136 1.66 3.369 2.499 4.789.555.939 1.446 1.219 2.245 1.219.53 0 1.02-.124 1.342-.26l9.222-3.356 9.107-3.315c1.202-.435 3.704-1.34 3.298-3.527",
    fill: props.color
  })));
}

export default SvgIconFlight;